<!--
    @负责人: libaiqi
    @创建时间: 2018-09-04
    @版本:v1.0.22
    @描述: 资源模型
    -->
<template>
  <div class="resourceModel__content">
    <div class="resourceModel__form">
      <el-form ref="form" :model="form" :inline="true" input-width="auto">
        <el-form-item>
          <el-input v-model="form.resourceName" :placeholder="$t('resourceModel.inputSearch')"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="e_search" v-g-rac="gRac('resourceModel@search')">{{ $t('common.search') }}</el-button>
          <el-button type="primary" @click="e_create" v-g-rac="gRac('resourceModel@createResource')">{{ $t('resourceModel.addResource') }}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="resourceModel__icon">
      <div v-for="(value,key) in modelList" :key="key" class="resourceModel__mb10">
        <div class="resourceModel__list resourceModel__mb10" >{{value}}</div>
        <div v-for="(item,index) in resourceList[key]" :key="index" class="resourceModel__item resourceModel__ilb resourceModel__mb10" :title="item.resourceName">
          <img class="resourceModel__img" src='../../../assets/image/cmdb/resorce.png'  @click="toManage(item)">
          <div class="resourceModel__mb10">{{item.resourceName}}</div>
        </div>
      </div>
    </div>
    <dialog-form
      key="createResourceModel"
      :title="$t('resourceModel.createResourceModel')" 
      :size="3" 
      :label-size="2" 
      :visible.sync="dialogFormShow" 
      :model="dialogModel"
      :input-data="dialogData"
      :rules="dialogFormRule"
      :confirm-fun="isConfirmCreate">
    </dialog-form>
  </div>
</template>
<script>
  import rac from '@/plugins/rac-mixin'
  import dic from '@/components/mixins/dic'
  import resourceModelBiz from '@/logic/cmdb/resourceModelBiz'
  import dialogForm from '@/components/dialogForm'
  import validateConfig from '@/utils/validate'

  export default {
    mixins: [rac, dic],
    components: {
      dialogForm
    },
    data () {
      return {
        form: {
          resourceName: ''
        },
        dialogFormShow: false,
        dialogModel: {},
        dialogData: [],
        dialogFormRule: {},
        modelList: {},
        resourceList: {},
        list: [],
        flag: 0
      }
    },
    methods: {
      e_init () {
        this.waitResourceTypeList()
      },
      async waitResourceTypeList () {
        await this.dGetDictionaryByCode('resourcemodel')
        this.modelList = { ...this.dDictionary.resourcemodel }
        this.setDialogData()
        this.getResource()
      },
      setDialogData () {
        this.dialogData = [
          {
            label: this.$t('resourceModel.resourceName'),
            key: 'resourceName'
          },
          {
            label: this.$t('resourceModel.resourceType'),
            key: 'resourceType',
            type: 'select',
            select: this.modelList
          },
          {
            label: this.$t('resourceModel.flagId'),
            key: 'flagId'
          },
          {
            label: this.$t('resourceModel.describe'),
            key: 'describe',
            type: 'textarea'
          }]
        this.dialogFormRule = {
          resourceName: [{ ...validateConfig.common.notEmpty }],
          resourceType: [{ ...validateConfig.common.notEmpty }],
          flagId: [{ ...validateConfig.common.notEmpty }]
        }
      },
      getResource (obj) {
        resourceModelBiz.getResource(obj).then((d) => {
          this.list = d
          this.flag++
        })
      },
      e_search () {
        this.getResource({resourceName: this.form.resourceName})
      },
      e_create () {
        this.dialogFormShow = true
        this.dialogModel = {
          resourceName: '',
          resourceType: Object.keys(this.modelList)[0],
          flagId: '',
          describe: ''
        }
      },
      toManage (data) {
        let query = {}
        query.resourceName = data.resourceName
        query.flagId = data.flagId
        query.resourceType = data.resourceType
        this.$router.push({ name: 'resourceManage', query: query })
      },
      isConfirmCreate (d) {
        const rule = /^[0-9a-zA-z-_]+$/
        const reg = new RegExp(rule)
        if (!reg.test(d.flagId)) {
          this.$message({
            message: this.$t('resourceModel.nameAlert'),
            type: 'warning'
          })
          return
        }
        resourceModelBiz.saveResource(d).then(() => {
          this.$message({
            message: this.$t('common.success'),
            type: 'success'
          })
        })
        setTimeout(() => {
          this.getResource()
        }, 100)
        this.dialogFormShow = false
      }
    },
    mounted () {
      this.e_init()
    },
    watch: {
      flag () {
        if (this.flag >= 1) {
          let list = {}
          Object.keys(this.modelList).forEach((item) => {
            list[item] = this.list.filter(({resourceType}) => resourceType === item)
          })
          this.resourceList = list
        }
      },
      $route (newV, oldV) {
        if (oldV.name === 'resourceManage' && newV.name === 'resourceModel') {
          this.getResource()
        }
      }
    }
  }
</script>
<style scoped>
  .resourceModel__content .resourceModel__icon {
    font-size: 14px;
  }
  .resourceModel__content .resourceModel__mb10 {
    margin-bottom: 10px;
  }
  .resourceModel__content .resourceModel__list{
    font-weight: 700;
  }
  .resourceModel__content .resourceModel__ilb{
    display: inline-block;
  }
  .resourceModel__content .resourceModel__img{
    margin: 0 auto;
    display: block; 
    cursor: pointer; 
  }
  .resourceModel__content .resourceModel__item{
    width: 120px;
  }
  .resourceModel__content .resourceModel__item div{
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>
